import { EnvironmentOutlined } from "@ant-design/icons";
import { Button, Card, Table, Tag, Tooltip } from "antd";
import type { ColumnsType } from "antd/es/table";
import { renderDateFormated, tagColors } from "../../../utils";
import { TicketContext } from "../../Shared/contexts/TicketContext";
import { useContext } from "react";

interface HistoryInterfaceProps {
  ticketInfo?: any;
}

interface DataType {
  key: string;
  user: string;
  description: string;
  type: string;
  date: string;
  latitude?: number;
  longitude?: number;
}

function History({ ticketInfo }: HistoryInterfaceProps) {
  const ticketContext = useContext(TicketContext) as any;
  const ticket = ticketInfo ? ticketInfo : ticketContext.ticket;
  const getTypeLabel = (type: string) =>
    type === "contact" ? "CONTATO" : type?.toUpperCase();
  const isValidCoordinate = (coordinate?: number | null) =>
    typeof coordinate === "number" && Number.isFinite(coordinate);

  const typeTags = [
    {
      text: "Sistema",
      value: "sistema",
    },
    {
      text: "Descrição",
      value: "descrição",
    },
    {
      text: "Status",
      value: "status",
    },
    {
      text: "Anexo",
      value: "anexo",
    },
    {
      text: "Ticket",
      value: "ticket",
    },
    {
      text: "Contato",
      value: "contact",
    },
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: "Data",
      dataIndex: "date",
      key: "date",
      width: 150,
      render: (date) => renderDateFormated(date),
      sorter: (a, b) => {
        const c: any = new Date(a.date);
        const d: any = new Date(b.date);
        return c - d;
      },
    },
    {
      title: "Usuário",
      dataIndex: "user",
      key: "user",
      width: 150,
    },
    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      render: (description, record) => {
        const hasLocation =
          isValidCoordinate(record.latitude) &&
          isValidCoordinate(record.longitude);
        const mapsUrl = hasLocation
          ? `https://www.google.com/maps?q=${record.latitude},${record.longitude}`
          : undefined;

        return (
          <div className="flex items-center gap-2">
            <span>{description}</span>
            {mapsUrl && (
              <Tooltip title="Abrir localização no Maps">
                <Button
                  href={mapsUrl}
                  target="_blank"
                  rel="noreferrer"
                  size="small"
                  type="text"
                  icon={<EnvironmentOutlined />}
                />
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "Tipo",
      key: "type",
      dataIndex: "type",
      filters: typeTags,
      onFilter: (value: any, record) => record.type.indexOf(value) === 0,
      render: (type) => (
        <Tag color={tagColors[type]}>{getTypeLabel(type)}</Tag>
      ),
      width: 200,
    },
  ];

  const history: DataType[] = ticket.history.map((log: any) => ({
    key: log.id,
    user: log.user?.fullName ?? "Sistema",
    description: log.actionDescription,
    type: log.referenceType.toLowerCase(),
    date: log.createdAt,
    latitude: log.latitude,
    longitude: log.longitude,
  }));

  return (
    <div className="pt-1">
      <Card
        title="Histórico"
        size="small"
        headStyle={{ color: " rgb(59 130 246)" }}
      >
        <Table
          className=" overflow-auto"
          size="small"
          columns={columns}
          dataSource={history}
          pagination={false}
          style={{ maxHeight: "25vh" }}
        />
      </Card>
    </div>
  );
}

export default History;
